export default class AttributeFilter {
  constructor (filterData) {
    this.code = filterData.code
    this.label = filterData.label
    this.type = filterData.type
  }
}
